import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga";

function GATracker({ history }) {
  //ReactGA.pageview(window.location.href);
  useEffect(() => {
    const unlisten = history.listen(() => {
      try {
        //console.error("GA", window.location.pathname + window.location.search);
        if (!window.location.pathname.startsWith("http://localhost")) {
          ReactGA.pageview(window.location.pathname + window.location.search);
        } else
        {
          console.log("tracked");
        }
      } catch (error) {
        console.error(error);
      }
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
}

export default withRouter(GATracker);
